import * as React from 'react';
import { sortPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import HistoryRow from '../../../../components/HistoryRow';
import HistoryRowControls from '../../../../components/HistoryRowControls';
import { IHistoryContext, withHistoryContext } from '../../../../containers/FormContextHandler';
import HistoryRowBasicItem from 'Components/HistoryRowBasicItem';
import { Container, Item } from 'Components/Grid';

const AriaSymptomsHistory = ({ documents, startEdit, fm }: IHistoryContext<IAriaSymptoms>): React.JSX.Element => {
  return (
    <React.Fragment>
      {documents
        ?.toSorted((d1, d2) => sortPartialDate(d2.date, d1.date))
        ?.map((d: IAriaSymptoms) => (
          <HistoryRow
            headerText={d.date ? formatPartialDate(d.date) : undefined}
            key={d._id}
            rowButton={startEdit && <HistoryRowControls document={d} startEdit={startEdit} />}
            controlsMargin={false}
          >
            <Container>
              <Item xs={3}>
                <HistoryRowBasicItem
                  header={fm('ariaSymptoms.symptomsFound')}
                  value={d.symptomsFound ? fm(`general.${d.symptomsFound}`) : '-'}
                />
              </Item>
              <Item xs={3}>
                {d.symptoms ? (
                  <HistoryRowBasicItem
                    header={fm('ariaSymptoms.symptoms')}
                    value={
                      <div>
                        {d.symptoms.map(symp => (
                          <div key={symp}>{fm(`ariaSymptoms.opts.${symp}`)}</div>
                        ))}
                      </div>
                    }
                  />
                ) : (
                  <></>
                )}
              </Item>
              <Item xs={true}>
                <HistoryRowBasicItem
                  header={fm('ariaSymptoms.additionalInformation')}
                  value={d.additionalInformation}
                />
              </Item>
            </Container>
          </HistoryRow>
        ))}
    </React.Fragment>
  );
};

export default withHistoryContext(AriaSymptomsHistory);
